import { render, staticRenderFns } from "./AppContent.vue?vue&type=template&id=cd44861e&scoped=true"
import script from "./AppContent.vue?vue&type=script&lang=js"
export * from "./AppContent.vue?vue&type=script&lang=js"
import style0 from "./AppContent.vue?vue&type=style&index=0&id=cd44861e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd44861e",
  null
  
)

export default component.exports